<mat-card-header id="cardHeader">
	<div fxLayout fxLayoutAlign="start center">
		<div mat-card-avatar>
			<mat-icon>{{ icon }}</mat-icon>
		</div>
		<mat-card-title>{{ title }}</mat-card-title>
	</div>
	<span class="spacer"></span>
	<button
		*ngIf="jobSummary"
		(click)="navigateToScheduling()"
		mat-stroked-button
		color="primary"
		class="assign-rwic-button"
	>
		Schedule Field Worker
	</button>
	<ng-content></ng-content>
</mat-card-header>
